import React from "react";
import { TextField } from "@mui/material";

export const ACCOUNT_INFO = "account_info";
export const PERSONAL_INFO = "personal_info";
export const TEXTFIELDS = [
  {
    maxLength: 120,
    label: "Username",
    register: "username",
    group: ACCOUNT_INFO,
    type: "text",
  },
  {
    maxLength: 120,
    label: "Name",
    register: "firstName",
    group: PERSONAL_INFO,
    type: "text",
  },
  {
    maxLength: 120,
    label: "LastName",
    register: "lastName",
    group: PERSONAL_INFO,
    type: "text",
  },
  {
    maxLength: 255,
    label: "Address",
    register: "address",
    group: PERSONAL_INFO,
    type: "text",
  },
  {
    maxLength: 64,
    label: "Oib",
    register: "oib",
    group: ACCOUNT_INFO,
    type: "text",
  },
  {
    maxLength: 15,
    label: "PhoneNumber",
    register: "phoneNumber",
    group: PERSONAL_INFO,
    type: "text",
  },
  {
    maxLength: 255,
    label: "Email",
    register: "email",
    group: ACCOUNT_INFO,
    type: "text",
  },
  {
    maxLength: 64,
    label: "Password",
    register: "password",
    group: ACCOUNT_INFO,
    type: "password",
  },
];
export const ADMIN_TEXT_FIELDS = [
  {
    maxLength: 120,
    label: "Username",
    register: "username",
    group: ACCOUNT_INFO,
    type: "text",
  },
  {
    maxLength: 64,
    label: "Oib",
    register: "oib",
    group: ACCOUNT_INFO,
    type: "text",
  },
  {
    maxLength: 64,
    label: "Password",
    register: "password",
    group: ACCOUNT_INFO,
    type: "password",
  },
];

export function SingleTextField({ textfield, t, errors, register, ...rest }) {
  return (
    <TextField
      inputProps={{ maxLength: textfield.maxLength }}
      label={t(textfield.label)}
      error={!!errors?.[textfield.register]}
      helperText={errors?.[textfield.register]?.message || ""}
      {...register(textfield.register)}
      type={textfield.type}
      {...rest}
    />
  );
}
